/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientAdminModel } from '../../models/patient-admin-model';

export interface AdminPost$Params {
      body?: PatientAdminModel
}

export function adminPost(http: HttpClient, rootUrl: string, params?: AdminPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, adminPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<string>;
    })
  );
}

adminPost.PATH = '/Admin';
